module.exports = __webpack_public_path__ + "static/media/cnc.5b04f6c3.png";